<template>
  <div>
    <div class="card mt-3">
      <div class="card-body p-0">
        <div class="tab-buttons d-flex border-bottom">
          <template v-for="chart in charts">
            <button
              v-if="chart.show()"
              :key="chart.value"
              :class="['tab-button', { active: activeTab === chart.value }]"
              @click="switchTab(chart.value)"
            >
              <el-tooltip
                :content="$t(`${chart.value}_chart_tooltip`)"
                :open-delay="100"
                placement="top"
                popper-class="adjust-width"
              >
                <i class="nc-icon nc-alert-circle-i tooltip-icon"></i>
              </el-tooltip>
              {{ $t(chart.label) }}
            </button>
          </template>
        </div>
        <!-- Main Iframe -->
        <div class="iframe-container position-relative flex-grow-1">
          <!-- Loader -->
          <div v-if="isLoading" class="loader-overlay">
            <div class="spinner"></div>
          </div>
          <iframe
            v-if="activeTab"
            :key="activeTab"
            :src="computedIframeSrc"
            frameborder="0"
            class="w-100 h-100"
            @load="iframeLoaded"
          ></iframe>
        </div>
      </div>
    </div>
    <!-- Extra Charts: Monthly Gains and Drawdown -->
    <div class="row-cols-wrapper mt-3">
      <div class="extra-chart-card">
        <div class="card">
          <div class="card-header">
            <el-tooltip
              :content="$t('def_chart_tooltip')"
              :open-delay="100"
              placement="top"
              popper-class="adjust-width"
            >
              <i class="nc-icon nc-alert-circle-i tooltip-icon"></i>
            </el-tooltip>
            {{ $t('drawdown') }}
          </div>
          <div class="card-body p-0">
            <iframe
              :src="iframeSrc('def')"
              frameborder="0"
              class="w-100 h-100"
              @load="iframeLoaded"
            ></iframe>
          </div>
        </div>
      </div>
      <div class="extra-chart-card">
        <div class="card">
          <div class="card-header">
            <el-tooltip
              :content="$t('mg_chart_tooltip')"
              :open-delay="100"
              placement="top"
              popper-class="adjust-width"
            >
              <i class="nc-icon nc-alert-circle-i tooltip-icon"></i>
            </el-tooltip>
            {{ $t('monthly_gains') }}
          </div>
          <div class="card-body p-0">
            <iframe
              :src="iframeSrc('mg')"
              frameborder="0"
              class="w-100 h-100"
              @load="iframeLoaded"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StrategyCharts',
  props: {
    account: { type: [String, Number], required: true },
    settings: { type: Object,  default: () => ({}) },
    forceShow: { type: Boolean, default: false },
  },
  computed: {
    computedIframeSrc() {
      return `https://charts.hokocloud.com/html/${this.activeTab}/${this.account}.html?nocache=${Date.now()}`;
    },
  },
  data() {
    return {
      charts: [
        { label: 'growth', value: 'bae', show: () => true },
        { label: 'balance', value: 'baen', show: () => this.settings.show_balance || this.forceShow },
        { label: 'total_profit', value: 'tg', show: () => this.settings.show_balance || this.forceShow  },
      ],
      activeTab: 'bae',
      isLoading: true,
    };
  },
  methods: {
    switchTab(tab) {
      if (this.activeTab !== tab) {
        this.isLoading = true;
        this.activeTab = tab;
      }
    },
    iframeLoaded() {
      setTimeout(() => {
        this.isLoading = false;
      }, 0);
    },
    iframeSrc(type) {
      return `https://charts.hokocloud.com/html/${type}/${this.account}.html?nocache=${Date.now()}`;
    },
  },
};
</script>

<style scoped>
.tab-buttons {
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.tab-button {
  padding: 0.5rem 1rem;
  cursor: pointer;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 0.9rem;
  transition: all 0.2s;
}
.tab-button:hover {
  background-color: #e9ecef;
}
.tab-button.active {
  border-bottom: 2px solid #007bff;
  font-weight: bold;
}
.iframe-container {
  position: relative;
  flex-grow: 1;
  min-height: 425px;
  height: 425px;
  overflow: hidden;
}
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.spinner {
  width: 48px;
  height: 48px;
  border: 6px solid #ccc;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
.row-cols-wrapper {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.extra-chart-card {
  flex: 1 1 48%;
  min-width: 280px;
}
.extra-chart-card iframe {
  height: 300px;
  min-height: 300px;
  border: none;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 512px) {
  .tab-button {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    white-space: nowrap;
  }
  .tab-buttons {
    flex-wrap: wrap;
    justify-content: center;
  }
  .extra-chart-card {
    flex: 1 1 100%;
  }
}
</style>
